import styled from 'styled-components'

import theme from 'theme_'
import { StyledIcon } from 'features/home/components/HomeStatus/styles'
import CommonLinkButton from 'components/Button/CommonLinkButton'
import { baseBlockStyles } from '../styles'

export const HomeUIDWrapper = styled(baseBlockStyles)`
  @media ${theme.devices.tablet} {
    flex-basis: 100%;
  }
  @media ${theme.devices.desktop} {
    flex-basis: 32%;
  }
`

export const HomeUIDCopy = styled.div`
  background: ${theme.colors.lighterGrey};
  border-radius: 8px;
  padding: 8px 16px 4px 16px;
  min-width: 240px;
  width: max-content;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const HomeUIDIcon = styled(StyledIcon)``

export const HomeUIDButton = styled(CommonLinkButton)`
  padding: 0;
`
